import type { AxiosInstance } from 'axios';
import { govApiLog } from '@gov-nx/core/app/log/log';
import type { AutorizaceSluzbaAutorizaceSeznamDto } from '../generated/autorizace.types';
import type {
	SecurityExtendedUserInfoDto,
	SecurityLogoutUrlDto,
	SecurityPotvrditKodZadostDTO,
	SecurityMobileTokenDto,
	SecurityOdeslatKodZadostDTO,
	SecurityZahajitAutorizaciOdpovedDTO,
	SecurityAutorizaceOdpovedDTO,
	SecurityPolozkaAutorizaceId,
} from '../generated/security.types';
import { logger } from '../logger';

export const authNiaRegisterQuery = async (
	axiosInstance: AxiosInstance,
	token: string
): Promise<SecurityMobileTokenDto> => {
	govApiLog('/auth/nia/register');
	logger('authNiaRegisterQuery call "/auth/nia/register" with token', [token]);
	const { data, status } = await axiosInstance.get('/auth/nia/register', {
		params: {
			// eslint-disable-next-line camelcase
			access_token: token,
		},
	});
	logger('authNiaRegisterQuery response of "/auth/nia/register" STATUS code', [
		status,
	]);
	return data;
};

export const authMeQuery = async (
	axiosInstance: AxiosInstance
): Promise<SecurityExtendedUserInfoDto> => {
	govApiLog('/api/v1/auth/me');
	const { data } = await axiosInstance.get('/api/v1/auth/me');
	return data;
};

export const authLogoutQuery = async (
	axiosInstance: AxiosInstance
): Promise<SecurityLogoutUrlDto> => {
	govApiLog('/api/v1/auth/logout');
	const { data } = await axiosInstance.get('/api/v1/auth/logout');
	return data;
};

export const zahajAutorizaci = async ({
	axiosInstance,
	polozkaAutorizaceId,
}: {
	axiosInstance: AxiosInstance;
	polozkaAutorizaceId: string;
}) =>
	axiosInstance.post<SecurityZahajitAutorizaciOdpovedDTO>(
		`api/v1/auth/autorizace/${polozkaAutorizaceId}/start`
	);

export const dokonciAutorizaci = async ({
	axiosInstance,
	authorizationId,
}: {
	axiosInstance: AxiosInstance;
	authorizationId: number;
}) =>
	axiosInstance.post<SecurityAutorizaceOdpovedDTO>(
		`api/v1/auth/autorizace/${authorizationId}/dokoncit`
	);

export const sendAuthCode = async ({
	axiosInstance,
	authorizationId,
	body,
}: {
	axiosInstance: AxiosInstance;
	authorizationId: number;
	body: SecurityOdeslatKodZadostDTO;
}) =>
	axiosInstance.post(
		`api/v1/auth/autorizace/${authorizationId}/odeslat-kod`,
		body
	);

export const confirmAuthCode = async ({
	axiosInstance,
	authorizationId,
	body,
}: {
	axiosInstance: AxiosInstance;
	authorizationId: number;
	body: SecurityPotvrditKodZadostDTO;
}) =>
	axiosInstance.post<SecurityAutorizaceOdpovedDTO>(
		`api/v1/auth/autorizace/${authorizationId}/potvrdit-kod`,
		body
	);

export const vypisSeznamSluzebProAutorizaci = async (
	axiosInstance: AxiosInstance
) =>
	axiosInstance.get<AutorizaceSluzbaAutorizaceSeznamDto>(
		'api/v1/auth/autorizace/seznam-sluzeb'
	);

export const vypisPolozkaAutorizaceId = async ({
	axiosInstance,
	ukonId,
}: {
	axiosInstance: AxiosInstance;
	ukonId: string;
}) =>
	axiosInstance.get<SecurityPolozkaAutorizaceId>(
		`api/v1/auth/autorizace/${ukonId}/polozka-autorizace-id`
	);
